<template>
	<div id="editButterfly">
		<div v-for="butterfly of butterflies.slice().reverse()" v-bind:key="butterfly['.key']">
			<div v-if="butterfly['.key']==id">
				<b-row>
					<b-col cols="10">
						<div >
							<div >
								<h4>Edit Butterfly</h4>
								<br>
								<b-row>
									<b-col cols="2">
										Scientific Name
									</b-col>
									<b-col>
										<b-form-input v-model="butterfly.scientificName"></b-form-input>
									</b-col>
								</b-row>
								<br>
								<b-row>
									<b-col cols="2">
										Common Name
									</b-col>
									<b-col>
										<b-form-input v-model="butterfly.commonName"></b-form-input>
									</b-col>
								</b-row>
								<br>
								<b-row>
									<b-col cols="2">
										Family
									</b-col>
									<b-col>
										<b-form-select v-model="butterfly.family" :options="family"></b-form-select>
									</b-col>
								</b-row>
								<br>
								<b-row>
									<b-col cols="2">
										Sub Family
									</b-col>
									<b-col>
										<b-form-select v-model="butterfly.subFamily" :options="subFamily"></b-form-select>
									</b-col>
								</b-row>
								<br>
								<b-row>
									<b-col cols="2">
										Longevity
									</b-col>
									<b-col>
										<b-form-input v-model="butterfly.longevity"></b-form-input>
									</b-col>
								</b-row>
								<br>
								<b-row>
									<b-col cols="2">
										Host Plant
									</b-col>
									<b-col>
										<b-form-input v-model="butterfly.hostPlant"></b-form-input>
									</b-col>
								</b-row>
								<br>
								<b-row>
									<b-col cols="2">
										Range
									</b-col>
									<b-col>
										<b-form-checkbox
										id="checkbox-1"
										v-model="butterfly.northAmerica"
										value="accepted"
										unchecked-value="not_accepted"
										>
										North America
									</b-form-checkbox>
								</b-col>
								<b-col>
									<b-form-checkbox
									id="checkbox-2"
									v-model="butterfly.southAmerica"
									value="accepted"
									unchecked-value="not_accepted"
									>
									South America
								</b-form-checkbox>
							</b-col>
							<b-col>
								<b-form-checkbox
								id="checkbox-3"
								v-model="butterfly.europe"
								value="accepted"
								unchecked-value="not_accepted"
								>
								Europe
							</b-form-checkbox>
						</b-col>
						<b-col>
							<b-form-checkbox
							id="checkbox-4"
							v-model="butterfly.africa"
							value="accepted"
							unchecked-value="not_accepted"
							>
							Africa
						</b-form-checkbox>
					</b-col>
					<b-col>
						<b-form-checkbox
						id="checkbox-5"
						v-model="butterfly.australia"
						value="accepted"
						unchecked-value="not_accepted"
						>
						Australia
					</b-form-checkbox>
				</b-col>
				<b-col>
					<b-form-checkbox
					id="checkbox-6"
					v-model="butterfly.asia"
					value="accepted"
					unchecked-value="not_accepted"
					>
					Asia
				</b-form-checkbox>
			</b-col>
			<b-col>
				<b-form-checkbox
				id="checkbox-7"
				v-model="butterfly.antartica"
				value="accepted"
				unchecked-value="not_accepted"
				>
				Antartica
			</b-form-checkbox>
		</b-col>
		<b-col>
			<b-form-checkbox
			id="checkbox-8"
			v-model="butterfly.unknown"
			value="accepted"
			unchecked-value="not_accepted"
			>
			Unknown
		</b-form-checkbox>
	</b-col>
</b-row>
<br>
<b-row>
	<b-col cols="2">
		Etymology
	</b-col>
	<b-col>
		<b-form-textarea v-model="butterfly.etymology"></b-form-textarea>
	</b-col>
</b-row>
<br>
<b-row>
	<b-col cols="2">
		Habitat
	</b-col>
	<b-col>
		<b-form-textarea v-model="butterfly.habitat"></b-form-textarea>
	</b-col>
</b-row>
<br>
<b-row>
	<b-col cols="2">
		Life History
	</b-col>
	<b-col>
		<b-form-textarea v-model="butterfly.lifeHistory"></b-form-textarea>
	</b-col>
</b-row>
<br>
<b-row>
	<b-col cols="2">
		Flight Duration (Starting Month)
	</b-col>
	<b-col>
		<b-form-select v-model="butterfly.startMonth" :options="months"></b-form-select>
	</b-col>
</b-row>
<br>
<b-row>
	<b-col cols="2">
		Flight Duration (Ending Month)
	</b-col>
	<b-col>
		<b-form-select v-model="butterfly.endMonth" :options="months"></b-form-select>
	</b-col>
</b-row>
<br>
<b-row>
	<b-col cols="2">
		Fun Fact
	</b-col>
	<b-col>
		<b-form-textarea v-model="butterfly.funFact"></b-form-textarea>
	</b-col>
</b-row>
<br>
<h5><u>Butterfly Traits</u></h5>
<br>
<b-row>
	<b-col cols="2">
		Size
	</b-col>
	<b-col @click="selectSize(butterfly, 'large')">
		<div v-if="butterfly.size == 'large'">
			<img src="../assets/large.png" height="150px" id="large" class="select">
		</div>
		<div v-else>
			<img src="../assets/large.png" height="150px" id="large">
		</div>
	</b-col>
	<b-col @click="selectSize(butterfly, 'medium')">
		<div v-if="butterfly.size == 'medium'">
			<img src="../assets/medium.png" height="150px" id="medium" class="select">
		</div>
		<div v-else>
			<img src="../assets/medium.png" height="150px" id="medium">
		</div>
	</b-col>
	<b-col @click="selectSize(butterfly, 'small')">
		<div v-if="butterfly.size == 'small'">
			<img src="../assets/small.png" height="150px" id="small" class="select">
		</div>
		<div v-else>
			<img src="../assets/small.png" height="150px" id="small">
		</div>
	</b-col>
</b-row>
<br>
<hr>
<b-row>
	<b-col cols="2">
		Number of walking legs
	</b-col>
	<b-col cols="1">
		<b-form-radio v-model="butterfly.legs" name="some-radios" value="4">4</b-form-radio>
	</b-col>
	<b-col cols="1">
		<b-form-radio v-model="butterfly.legs" name="some-radios" value="6">6</b-form-radio>
	</b-col>
</b-row>
<br>
<hr>
<b-row>
	<b-col cols="2">
		Top Wing Feature(s)
	</b-col>
	<b-col @click="selectTop(butterfly, 'iridescent')">
		<div v-if="butterfly.iridescentTop == true">
			<img src="../assets/iridescent.jpg" height="100px" id="iridescent" class="select">
		</div>
		<div v-else>
			<img src="../assets/iridescent.jpg" height="100px" id="iridescent">
		</div>
	</b-col>
	<b-col @click="selectTop(butterfly, 'spotted')">
		<div v-if="butterfly.spottedTop == true">
			<img src="../assets/spotted.jpg" height="100px" id="spotted" class="select">
		</div>
		<div v-else>
			<img src="../assets/spotted.jpg" height="100px" id="spotted">
		</div>
	</b-col>
	<b-col @click="selectTop(butterfly, 'striped')">
		<div v-if="butterfly.stripedTop == true">
			<img src="../assets/striped.jpg" height="100px" id="striped" class="select">
		</div>
		<div v-else>
			<img src="../assets/striped.jpg" height="100px" id="striped">
		</div>
	</b-col>
	<b-col @click="selectTop(butterfly, 'veins')">
		<div v-if="butterfly.veinsTop == true">
			<img src="../assets/veins.jpg" height="100px" id="veins" class="select">
		</div>
		<div v-else>
			<img src="../assets/veins.jpg" height="100px" id="veins">
		</div>
	</b-col>
</b-row>
<br>
<hr>
<b-row>
	<b-col cols="2">
		Bottom Wing Feature(s)
	</b-col>
	<b-col @click="selectBottom(butterfly, 'iridescent')">
		<div v-if="butterfly.iridescentBottom == true">
			<img src="../assets/iridescent.jpg" height="100px" id="iridescent" class="select">
		</div>
		<div v-else>
			<img src="../assets/iridescent.jpg" height="100px" id="iridescent">
		</div>
	</b-col>
	<b-col @click="selectBottom(butterfly, 'spotted')">
		<div v-if="butterfly.spottedBottom == true">
			<img src="../assets/spotted.jpg" height="100px" id="spotted" class="select">
		</div>
		<div v-else>
			<img src="../assets/spotted.jpg" height="100px" id="spotted">
		</div>
	</b-col>
	<b-col @click="selectBottom(butterfly, 'striped')">
		<div v-if="butterfly.stripedBottom == true">
			<img src="../assets/striped.jpg" height="100px" id="striped" class="select">
		</div>
		<div v-else>
			<img src="../assets/striped.jpg" height="100px" id="striped">
		</div>
	</b-col>
	<b-col @click="selectBottom(butterfly, 'veins')">
		<div v-if="butterfly.veinsBottom == true">
			<img src="../assets/veins.jpg" height="100px" id="veins" class="select">
		</div>
		<div v-else>
			<img src="../assets/veins.jpg" height="100px" id="veins">
		</div>
	</b-col>
</b-row>
<br>
<hr>
<b-row>
	<b-col cols="2">
		Wing Shape
	</b-col>
	<b-col @click="selectWing(butterfly, 'heliconius')">
		<div v-if="butterfly.shape == 'heliconius'">
			<img src="../assets/heliconius.jpg" height="150px" id="heliconius" class="select">
		</div>
		<div v-else>
			<img src="../assets/heliconius.jpg" height="150px" id="heliconius.jpg">
		</div>
	</b-col>
	<b-col @click="selectWing(butterfly, 'nymphalidae')">
		<div v-if="butterfly.shape == 'nymphalidae'">
			<img src="../assets/nymphalidae.jpg" height="150px" id="nymphalidae" class="select">
		</div>
		<div v-else>
			<img src="../assets/nymphalidae.jpg" height="150px" id="nymphalidae">
		</div>
	</b-col>
	<b-col @click="selectWing(butterfly, 'papilionidae')">
		<div v-if="butterfly.shape == 'papilionidae'">
			<img src="../assets/papilionidae.jpg" height="150px" id="papilionidae" class="select">
		</div>
		<div v-else>
			<img src="../assets/papilionidae.jpg" height="150px" id="papilionidae">
		</div>
	</b-col>
	<b-col @click="selectWing(butterfly, 'pieridae')">
		<div v-if="butterfly.shape == 'pieridae'">
			<img src="../assets/pieridae.jpg" height="150px" id="pieridae" class="select">
		</div>
		<div v-else>
			<img src="../assets/pieridae.jpg" height="150px" id="pieridae">
		</div>
	</b-col>
	<b-col @click="selectWing(butterfly, 'saturniidae')">
		<div v-if="butterfly.shape == 'saturniidae'">
			<img src="../assets/saturniidae.jpg" height="150px" id="saturniidae" class="select">
		</div>
		<div v-else>
			<img src="../assets/saturniidae.jpg" height="150px" id="saturniidae">
		</div>
	</b-col>
</b-row>
<br>
<hr>
<b-row>
	<b-col cols="2">
		Tails
	</b-col>
	<b-col @click="selectTail(butterfly, 'tail')" cols="2">
		<div v-if="butterfly.tail == 'tail'">
			<img src="../assets/tail.png" height="150px" id="tail" class="select">
		</div>
		<div v-else>
			<img src="../assets/tail.png" height="150px" id="tail">
		</div>
	</b-col>
	<b-col @click="selectTail(butterfly, 'no_tail')" cols="2">
		<div v-if="butterfly.tail == 'no_tail'">
			<img src="../assets/no_tail.png" height="150px" id="no_tail" class="select">
		</div>
		<div v-else>
			<img src="../assets/no_tail.png" height="150px" id="no_tail">
		</div>
	</b-col>
</b-row>
<br>
<hr>
<b-row>
	<b-col cols="2">
		Antenna
	</b-col>
	<b-col @click="selectAntenna(butterfly, 'feathered')" cols="2">
		<div v-if="butterfly.antenna == 'feathered'">
			<img src="../assets/feathered.png" height="70px" id="feathered" class="select">
		</div>
		<div v-else>
			<img src="../assets/feathered.png" height="70px" id="feathered">
		</div>
	</b-col>
	<b-col @click="selectAntenna(butterfly, 'clubbed')" cols="2">
		<div v-if="butterfly.antenna == 'clubbed'">
			<img src="../assets/clubbed.png" height="70px" id="clubbed" class="select">
		</div>
		<div v-else>
			<img src="../assets/clubbed.png" height="70px" id="clubbed">
		</div>
	</b-col>
</b-row>
<br>
<hr>
<b-row>
	<b-col cols="2">
		Food
	</b-col>
	<b-col @click="selectFood(butterfly, 'flower_nectar')" cols="2">
		<div v-if="butterfly.flower_nectar == true">
			<img src="../assets/flower_nectar.png" height="150px" id="flower_nectar" class="select">
		</div>
		<div v-else>
			<img src="../assets/flower_nectar.png" height="150px" id="flower_nectar">
		</div>
	</b-col>
	<b-col @click="selectFood(butterfly, 'fruit')" cols="2">
		<div v-if="butterfly.fruit == true">
			<img src="../assets/fruit.png" height="150px" id="fruit" class="select">
		</div>
		<div v-else>
			<img src="../assets/fruit.png" height="150px" id="fruit">
		</div>
	</b-col>
</b-row>
<br>
<hr>
<b-row>
	<b-col cols="2">
		Resting Position
	</b-col>
	<b-col @click="selectResting(butterfly, 'closed')" cols="2">
		<div v-if="butterfly.resting == 'closed'">
			<img src="../assets/closed.png" height="150px" id="closed" class="select">
		</div>
		<div v-else>
			<img src="../assets/closed.png" height="150px" id="closed">
		</div>
	</b-col>
	<b-col @click="selectResting(butterfly, 'open')" cols="2">
		<div v-if="butterfly.resting == 'open'">
			<img src="../assets/open.png" height="150px" id="open" class="select">
		</div>
		<div v-else>
			<img src="../assets/open.png" height="150px" id="open">
		</div>
	</b-col>
</b-row>
<br>
<hr>
<b-row>
	<b-col><h5><u>Add Images</u></h5></b-col>
</b-row>
<br>
<b-row>
	<b-col><b-input v-model="description" placeholder="Add a description..."></b-input></b-col>
	<b-col cols="8"><b-form-file
		@change="onChange"
		placeholder="Choose a file or drop it here..."
		drop-placeholder="Drop file here..."
		></b-form-file></b-col>
		<b-col cols="2"><b-button @click="bImageAdd(butterfly)" style="width:100%"><b-icon-plus></b-icon-plus></b-button></b-col>
	</b-row>
	<br>
	<b-row>

		<b-col cols ="2" class="onHover" v-if="!(butterfly.fileName==='') && !(butterfly.url==='')">
			<b-card
			style="max-width: 20rem;"
			class="mb-2 onHover"
			v-b-modal="butterfly['.key']">
			<b-img-lazy :src="butterfly.url" fluid alt="No image" class="mb-2"></b-img-lazy>
			<b-card-text class="text-center" >
				Main Image
			</b-card-text>
		</b-card>
		<b-modal v-bind:id="butterfly['.key']" size="lg" hide-footer hide-header>
			<b-button variant="danger" style="float:right; margin-bottom:10px" @click="mainImageRemove(butterfly)"><b-icon-trash></b-icon-trash></b-button>
			<b-img-lazy :src="butterfly.url" alt="Fluid image" id="modalImg" style="width:100%"></b-img-lazy>
			<b-row class="text-center"><b-col><h4>Main Image</h4></b-col></b-row>
		</b-modal>
	</b-col>

	<b-col class="onHover" v-for="bImage of bImages.slice().reverse().filter(thisImages)" cols="2" v-bind:key="bImage['.key']" 
	v-b-modal="bImage['.key']">
	<b-card
	style="max-width: 20rem;"
	class="mb-2 onHover"
	v-b-modal="bImage['.key']">
	<b-img-lazy :src="bImage.url" fluid alt="No image" class="mb-2"></b-img-lazy>
	<b-card-text class="text-center" >
		{{bImage.description}}
	</b-card-text>
</b-card>
<b-modal v-bind:id="bImage['.key']" size="lg" hide-footer hide-header>
	<b-button variant="danger" style="float:right; margin-bottom:10px" @click="bImageRemove(bImage)"><b-icon-trash></b-icon-trash></b-button>
	<b-img-lazy :src="bImage.url" alt="Fluid image" id="modalImg" style="width:100%"></b-img-lazy>
	<b-row class="text-center"><b-col><h4>{{bImage.description}}</h4></b-col></b-row>
</b-modal>
</b-col>	
</b-row>

</div>
</div>
</b-col>
<b-col cols="2">
	<div class="sticky"><b-button class="mt-4 sticky-bottom" @click="save(butterfly)" style="width:100%;">Save</b-button></div>
</b-col>
</b-row>
</div>
</div>
<div id="snackbar">{{toastMessage}}</div>
</div>
</template>

<style>
#editButterfly{
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: #2c3e50;
	padding: 50px 50px 50px 50px;
}

div.sticky {
	position: -webkit-sticky;
	position: sticky;
	top: 60px;
	font-size: 20px;
}

.onHover:hover{
	opacity: 0.8;
	cursor: pointer;
}

.select{
	padding: 3px 3px 3px 3px;
	background-color: black;
	border-radius: 10px 10px 10px 10px;
	opacity: 0.7;
}

#snackbar {
	visibility: hidden; /* Hidden by default. Visible on click */
	min-width: 250px; /* Set a default minimum width */
	margin-left: -125px; /* Divide value of min-width by 2 */
	background-color: #333; /* Black background color */
	color: #fff; /* White text color */
	text-align: center; /* Centered text */
	border-radius: 2px; /* Rounded borders */
	padding: 16px; /* Padding */
	position: fixed; /* Sit on top of the screen */
	z-index: 1; /* Add a z-index if needed */
	left: 45%; /* Center the snackbar */
	bottom: 30px; /* 30px from the bottom */
}


#snackbar.show {
	visibility: visible; 
	-webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
	animation: fadein 0.5s, fadeout 0.5s 2.5s;
}

/* Animations to fade the snackbar in and out */
@-webkit-keyframes fadein {
	from {bottom: 0; opacity: 0;}
	to {bottom: 30px; opacity: 1;}
}

@keyframes fadein {
	from {bottom: 0; opacity: 0;}
	to {bottom: 30px; opacity: 1;}
}

@-webkit-keyframes fadeout {
	from {bottom: 30px; opacity: 1;}
	to {bottom: 0; opacity: 0;}
}

@keyframes fadeout {
	from {bottom: 30px; opacity: 1;}
	to {bottom: 0; opacity: 0;}
}
</style>


<script type="text/javascript">
import { butterflyRef } from '../firebase';
import { bImagesRef } from '../firebase';
import { firebaseStorage } from '../firebase';

export default {
	name: 'editButterfly',
	data () {
		return {
			butterflies: [],
			id: null,
			toastMessage: '',
			bImages: [],
			image: null,
			uploadTask: false,
			description: '',
			months: [
			{ value: 'January', text: 'January' },
			{ value: 'February', text: 'February' },
			{ value: 'March', text: 'March' },
			{ value: 'April', text: 'April' },
			{ value: 'May', text: 'May'},
			{ value: 'June', text: 'June'},
			{ value: 'July', text: 'July'},
			{ value: 'August', text: 'August'},
			{ value: 'September', text: 'September'},
			{ value: 'October', text: 'October'},
			{ value: 'November', text: 'November'},
			{ value: 'December', text: 'December'},
			],
			family: [
			{ value: 'Unknown', text: 'Unknown' },
			{ value: 'Hesperidae', text: 'Hesperidae' },
			{ value: 'Lycanidae', text: 'Lycanidae' },
			{ value: 'Nymphalidae', text: 'Nymphalidae' },
			{ value: 'Papilionidae', text: 'Papilionidae'},
			{ value: 'Pieridae', text: 'Pieridae'},
			{ value: 'Riodinidae', text: 'Riodinidae'},
			{ value: 'Saturniidae', text: 'Saturniidae'},
			],
			subFamily: [
			{ value: 'Unknown', text: 'Unknown' },
			{ value: 'Apaturinae', text: 'Apaturinae' },
			{ value: 'Baroniinae', text: 'Baroniinae' },
			{ value: 'Biblidinae', text: 'Biblidinae' },
			{ value: 'Calinaginae', text: 'Calinaginae' },
			{ value: 'Charaxinae', text: 'Charaxinae' },
			{ value: 'Coeliadinae', text: 'Coeliadinae' },
			{ value: 'Curetinae', text: 'Curetinae' },
			{ value: 'Cyrestinae', text: 'Cyrestinae' },
			{ value: 'Danainae', text: 'Danainae' },
			{ value: 'Dismorphiinae', text: 'Dismorphiinae' },
			{ value: 'Eudaminae', text: 'Eudaminae' },
			{ value: 'Euschemoninae', text: 'Euschemoninae' },
			{ value: 'Euselasiinae', text: 'Euselasiinae' },
			{ value: 'Heliconiinae', text: 'Heliconiinae' },
			{ value: 'Hesperiinae', text: 'Hesperiinae' },
			{ value: 'Heteropterinae', text: 'Heteropterinae' },
			{ value: 'Libytheinae', text: 'Libytheinae' },
			{ value: 'Limenitidinae', text: 'Limenitidinae' },
			{ value: 'Lycaeninae', text: 'Lycaeninae' },
			{ value: 'Megathyminae', text: 'Megathyminae' },
			{ value: 'Miletinae', text: 'Miletinae' },
			{ value: 'Morphinae', text: 'Morphinae' },
			{ value: 'Nymphalidae', text: 'Nymphalidae' },
			{ value: 'Parnassiinae', text: 'Parnassiinae' },
			{ value: 'Papilioninae', text: 'Papilioninae' },
			{ value: 'Pierinae', text: 'Pierinae' },
			{ value: 'Polyommatinae', text: 'Polyommatinae' },
			{ value: 'Poritiinae', text: 'Poritiinae' },
			{ value: 'Pseudergolinae', text: 'Pseudergolinae' },
			{ value: 'Pseudopontiinae', text: 'Pseudopontiinae' },
			{ value: 'Pyrginae', text: 'Pyrginae' },
			{ value: 'Riodinidae', text: 'Riodinidae' },
			{ value: 'Satyrinae', text: 'Satyrinae' },
			{ value: 'Saturniinae', text: 'Saturniinae' },
			{ value: 'Theclinae', text: 'Theclinae' },
			{ value: 'Trapezitinae', text: 'Trapezitinae' },
			],
		}
	},
	firebase: {
		butterflies: butterflyRef,
		bImages: bImagesRef
	},
	created() {
		this.id = this.$route.params.id;		
	},
	methods: {
		selectSize(butterfly, size){
			butterfly.size = size;
		},
		selectTop(butterfly, top){
			if(top == 'iridescent'){
				if(butterfly.iridescentTop == false){
					butterfly.iridescentTop = true;
				}else{
					butterfly.iridescentTop = false;
				}
			}else if(top == 'striped'){
				if(butterfly.stripedTop == false){
					butterfly.stripedTop = true;
				}else{
					butterfly.stripedTop = false;
				}
			}else if(top == 'spotted'){
				if(butterfly.spottedTop == false){
					butterfly.spottedTop = true;
				}else{
					butterfly.spottedTop = false;
				}
			}else if(top == 'veins'){
				if(butterfly.veinsTop == false){
					butterfly.veinsTop = true;
				}else{
					butterfly.veinsTop = false;
				}
			}	
		},
		selectBottom(butterfly, bottom){
			if(bottom == 'iridescent'){
				if(butterfly.iridescentBottom == false){
					butterfly.iridescentBottom = true;
				}else{
					butterfly.iridescentBottom = false;
				}
			}else if(bottom == 'striped'){
				if(butterfly.stripedBottom == false){
					butterfly.stripedBottom = true;
				}else{
					butterfly.stripedBottom = false;
				}
			}else if(bottom == 'spotted'){
				if(butterfly.spottedBottom == false){
					butterfly.spottedBottom = true;
				}else{
					butterfly.spottedBottom = false;
				}
			}else if(bottom == 'veins'){
				if(butterfly.veinsBottom == false){
					butterfly.veinsBottom = true;
				}else{
					butterfly.veinsBottom = false;
				}
			}	
		},
		selectWing(butterfly, shape){
			butterfly.shape = shape;
		},
		selectTail(butterfly, tail){
			butterfly.tail = tail;
		},
		selectAntenna(butterfly, antenna){
			butterfly.antenna = antenna;
		},
		selectFood(butterfly, food){
			if(food == 'flower_nectar'){
				if(butterfly.flower_nectar == false){
					butterfly.flower_nectar = true;
				}else{
					butterfly.flower_nectar = false;
				}
			}else if(food == 'fruit'){
				if(butterfly.fruit == false){
					butterfly.fruit = true;
				}else{
					butterfly.fruit = false;
				}
			}
		},
		selectResting(butterfly, resting){
			butterfly.resting = resting;
		},
		showSnackBar(message){
			this.toastMessage = message;
			var x = document.getElementById("snackbar");
			x.className = "show";
			setTimeout(function(){ x.className = x.className.replace("show", ""); }, 3000);
		},
		save(butterfly){
			var key = butterfly['.key'];
			butterflyRef.child(key).update({scientificName: butterfly.scientificName,
				commonName: butterfly.commonName,
				family: butterfly.family?butterfly.family:'',
				subFamily: butterfly.subFamily?butterfly.subFamily:'',
				longevity: butterfly.longevity?butterfly.longevity:'',
				hostPlant: butterfly.hostPlant?butterfly.hostPlant:'',
				northAmerica: butterfly.northAmerica?butterfly.northAmerica:'',
				southAmerica: butterfly.southAmerica?butterfly.southAmerica:'',
				europe: butterfly.europe?butterfly.europe:'',
				africa: butterfly.africa?butterfly.africa:'',
				australia: butterfly.australia?butterfly.australia:'',
				antartica: butterfly.antartica?butterfly.antartica:'',
				asia: butterfly.asia?butterfly.asia:'',
				unknown: butterfly.unknown?butterfly.unknown:'',
				etymology: butterfly.etymology?butterfly.etymology:'',
				habitat: butterfly.habitat?butterfly.habitat:'',
				lifeHistory: butterfly.lifeHistory?butterfly.lifeHistory:'',
				startMonth: butterfly.startMonth?butterfly.startMonth:'',
				endMonth: butterfly.endMonth?butterfly.endMonth:'',
				funFact: butterfly.funFact?butterfly.funFact:'',
				size: butterfly.size?butterfly.size:'',
				legs: butterfly.legs?butterfly.legs:'',
				iridescentTop: butterfly.iridescentTop?butterfly.iridescentTop:'',
				spottedTop: butterfly.spottedTop?butterfly.spottedTop:'',
				stripedTop: butterfly.stripedTop?butterfly.stripedTop:'',
				veinsTop: butterfly.veinsTop?butterfly.veinsTop:'',
				iridescentBottom: butterfly.iridescentBottom?butterfly.iridescentBottom:'',
				spottedBottom: butterfly.spottedBottom?butterfly.spottedBottom:'',
				stripedBottom: butterfly.stripedBottom?butterfly.stripedBottom:'',
				veinsBottom: butterfly.veinsBottom?butterfly.veinsBottom:'',
				shape: butterfly.shape?butterfly.shape:'',
				tail: butterfly.tail?butterfly.tail:'',
				antenna: butterfly.antenna?butterfly.antenna:'',
				flower_nectar: butterfly.flower_nectar?butterfly.flower_nectar:'',
				fruit: butterfly.fruit?butterfly.fruit:'',
				resting: butterfly.resting?butterfly.resting:''
			});
			this.showSnackBar('Butterfly Updated');
		},
		onChange(){
			this.image = event.target.files[0];
		},
		bImageAdd(butterfly){
			if(this.image == null || this.description == ''){
				this.showSnackBar('Please fill out all the fields');
				return;
			}

			var date = new Date();
			var imageName = this.image.name+date;
			var task = firebaseStorage.child(imageName).put(this.image);   
			task.on('state_changed', function(snapshot){
				var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
				console.log('Upload is ' + progress + '% done');
			});

			task.on(
				'state_changed',
				null,
				null,
				() => {
					console.log('upload complete!');
					firebaseStorage.child(imageName).getDownloadURL().then((url) => { 
						bImagesRef.push({id: butterfly['.key'], url: url, fileName: imageName, description: this.description});
					});
				});

			this.showSnackBar('Image Added');
			this.image = null;
		},
		bImageRemove(bImage){
			firebaseStorage.child(bImage.fileName).delete();
			bImagesRef.child(bImage['.key']).remove();
			this.showSnackBar('Image Deleted');
		},
		thisImages(bImg){
			return bImg.id==this.id ? bImg:null;
		},
		thisButterfly(thisButterfly){
			return thisButterfly['.key']==this.id ? thisButterfly:null;
		},
		mainImageRemove(butterfly){
			firebaseStorage.child(butterfly.fileName).delete();
			butterflyRef.child(butterfly['.key']).update({url: ''});
		}
	}
}
</script>


